import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@web/env/environment';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const unauthorizedInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const router = inject(Router);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        router.navigateByUrl(`${environment.iam['paths'].login}?refresh=true`);
      }
      return throwError(() => error);
    })
  );
};
